module.exports = __webpack_public_path__ + "img/29t.67fa6acf.jpg";